import React, { FC } from 'react';

interface MobileLangSelectProps {
  handleLanguage: (selected: string) => void;
  availableLanguages: string[];
  selectedLanguage: string;
}

export const MobileLangSelect: FC<MobileLangSelectProps> = ({
  handleLanguage,
  availableLanguages,
  selectedLanguage,
}) => {
  return (
    <div className="mobile-lang-select">
      {availableLanguages.map((el) => {
        return (
          <button
            key={el}
            type="button"
            className={
              selectedLanguage === el
                ? 'mobile-lang-select__elem mobile-lang-select__elem_selected'
                : 'mobile-lang-select__elem'
            }
            onClick={() => handleLanguage(el)}
            onKeyPress={() => handleLanguage(el)}
          >
            {el}
          </button>
        );
      })}
    </div>
  );
};
